module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WOULD NEVER")]), _vm._v(" have undertaken or completed this project without the constant support of my lovely wife, Sandy, who reviewed and made helpful suggestions and comments on a series of drafts and was a ready source of encouragement when I bogged down. I am much indebted for her aid and comfort throughout the process.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of old friends were helpful, cudgeling my enfeebled memory and correcting my sometimes erratic notions of past events. My particular thanks go out to Jan Reid, Kaye Northcott, Oscar Mauzy, and Molly Ivins, who read early drafts and supplied both encouragement and helpful suggestions. Thanks also to Julie Ford, who graciously volunteered to help me avoid problems of defamation. Finally, I would never have made it without my sons Clark and Sam, who repeatedly rescued me from computer snafus."), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("After three defeats, two quite narrow, in races for governor, Ralph Yarborough won a special election in 1957 to the U.S. Senate, to the great joy of his fervent supporters. Yarborough had a distinguished Senate record and was the only senator from the Old South who consistently supported civil rights legislation. He defeated George Bush in his Senate reelection campaign of 1964. Photograph courtesy of the Center For American History, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v("-Austin, Lee (Russell) Photograph Collection, 1935–1937, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CN")]), _vm._v("# 10747.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f5a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Henry Gonzalez, then state senator from San Antonio, led the fight against the segregation bills in the 1957 legislative session. He ran unsuccessfully for governor in 1958 against Price Daniel. Here he is shown being welcomed at the Democrats of Texas Convention, liberal counterpart to the official state party organization. Photograph courtesy of the Center For American History, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v("-Austin, Lee (Russell) Photograph Collection, 1935–1937, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CN")]), _vm._v("# 10748."), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Arthur Weaver and his wife pictured in front of their grocery store on Butt Street in Nacogdoches, Texas. Mr. Weaver was an indomitable civil rights activist in Nacogdoches and the lead plaintiff in two successful voting rights cases against both the city and the county of Nacogdoches. The 1974 county suit resulted in the first Black county official elected in Texas in the twentieth century.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f6a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The largest antiwar march in Austin occurred in May 1970, shortly after the Kent State shootings. It turned into a peaceful demonstration after a week or more of tense confrontations between activists and Austin police. It was peaceful thanks to U.S. District Judge Jack Roberts, who ordered the city of Austin to allow the march to go forward. Photograph courtesy of the Center For American History, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v("-Austin, Prints and Photographs Collection, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CN")]), _vm._v("# 10745."), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The farmworkers march began in the Texas Valley, in Mission, Texas, in the summer of 1966 as an outgrowth of labor organizing and the La Casita melon strike. The march culminated in Austin on Labor Day with a huge rally on the capitol grounds. This was a major event in the awakening of politics among Mexican Americans in South Texas. Pictured in the front row are Eugene Nelson, farmworker organizer; Reverend James Navarro; and Father Antonio González. Roy Evans and Hank Brown of the Texas "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AFL-CIO")]), _vm._v(" can be seen in the right background.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f7a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The Mad Dog Board of Directors meeting. I believe this was the only time it ever gathered—probably fortunately. Seated at the table from left to right are Mike Hershey, someone impersonating Gary Cartwright, Bud Shrake, and the author. Other attendees remain nameless. Photograph courtesy of the Center For American History, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v("-Austin, Hershorn (Shel) Photograph Collection, ca. 1953–1996, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CN")]), _vm._v("# 10793."), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("In the days preceding the May 1970 peace march, Austin police encouraged "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v(" students and other peace activists to confine themselves to the campus area. Photograph courtesy of the Center For American History, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v("-Austin, Prints and Photographs Collection, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CN")]), _vm._v("# 10177.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f8a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The site of many a pleasant gathering over a twenty-year period: my old farm on the North San Gabriel, near Liberty Hill. Campers visible from left to right are my wife, Sandy, John Duncan, Larry Sauer, Kaye Northcott, Becky Beaver, and Molly Ivins, with various offspring in the background."), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Franklin García was a longtime organizer for the Amalgamated Meat-cutters Union. He was a prime mover in labor activities throughout the Hispanic world of South Texas and was instrumental in the farm-workers’ movement and in the political change in South Texas.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f9a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Governor Preston Smith ordered "), _c('span', {
    staticClass: "small"
  }, [_vm._v("VISTA")]), _vm._v(" workers out of Del Rio and Val Verde County in 1968 because of complaints that the volunteers were engaged in politics that threatened the old order. A sizable protest march and rally ensued. Among those in attendance were now State Senator Gonzalo Barrientos and now State Representative Elliot Naishtat, both of Austin. Photograph courtesy of the Center For American History, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v("-Austin, Hershorn (Shel) Photograph Collection, ca. 1953–1996, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CN")]), _vm._v("# 10750."), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Frank Robinson (right) was a civil rights activist in Palestine, Texas, and the lead plaintiff in voting rights litigation concerning Anderson County and the city of Palestine. His untimely death has been a source of controversy, as his family and supporters have always believed he was murdered as a result of his civil rights activities. Pictured also is former State Representative Paul Ragsdale from Dallas. Paul is standing before a map detailing his East Texas voting rights project, a largely successful effort we made to increase the number of Black officeholders in East Texas. Photograph courtesy of the Center For American History, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v("-Austin, Robinson (Frank J.) Papers, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CN")]), _vm._v("# 10746.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f10a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("In the early 1970s, the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v(" Shuttle Bus Drivers Union was formed and struck for recognition and a contract. Two protracted strikes occurred in those years, and the union became a source of political activism in Austin. At this writing, two former union leaders hold public office in Travis County, County Attorney Ken Oden and Probate Judge Guy Herman. Photograph © copyright Alan Pogue."), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Martin Wiginton and Bobby Nelson were two of Austin’s most notable political activists during the 1960s and 1970s. They conceived of and managed two of Austin’s most important music venues: the Alamo Lounge, pictured here, and Emma Joe’s, named for Emma Goldman and Joe Hill. Emma Goldman is credited with the line that goes something like this: If there is not going to be dancing in your revolution, count me out.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f11a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Lyndon Johnson and Frank Erwin, probably working on their enemy list."), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Yarborough Democrats celebrated great victories in 1982 with the election of Ann Richards to state treasurer, Jim Hightower to agriculture commissioner, Garry Mauro to land commissioner, and Jim Mattox to attorney general. Pictured here, from left to right, are Garry Mauro, Jim Hightower, and Ann, on the happy occasion of their swearing in. Photograph courtesy of the Center For American History, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v("-Austin, Richards (Ann W.) Papers, 1933–1999, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CN")]), _vm._v("# 10702."), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f12a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("As described in "), _c('span', {
    attrs: {
      "href": "#/html/9780292749061_29_ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")]), _vm._v(", I went to work for Jim Mattox when he took office in 1983. Some months into his administration, Mattox was indicted by District Attorney Ronnie Earle out of a political brouhaha. In order to give courage to the staff of the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AG")]), _vm._v("‘s office during those unsettled times, a meeting was held of the hundreds of employees of the office. As we bigwigs sat on the stage, a pizza delivery boy arrived, sent by some wag—my future partner Phil Durst—and delivered me a pizza. This picture resulted. On the front row are Mattox, Tom Green, yours truly, and Harmon Lisnow. Behind us are the various division chiefs of the office."), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "htitle",
    staticStyle: {
      "margin-top": "0em"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "htitle",
    staticStyle: {
      "margin-top": "0em"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "htitle",
    staticStyle: {
      "margin-top": "0em"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "htitle",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_vm._v("Once Upon a Time in Texas"), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("A shot taken by my wife, Sandy, at the entrance to St. Helena Canyon in the Big Bend, one of the lovely spots in Texas. In the foreground, you can barely make out that intrepid adventurer Mike Sharlot of the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v(" Law School.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a450ae6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292749061_07_ack.vue
// module id = 75
// module chunks = 0